export const headerMenu = () => {
    // Get DOM elements
    const elements = {
      mobileMenuBtn: document.querySelector(".header__menu-toggle"),
      header: document.querySelector(".header"),
      menuItemIcons: document.querySelectorAll(".header__nav-link-icon"),
      body: document.querySelector("body"),
      nav: document.querySelector(".header__nav"),
      submenus: document.querySelectorAll(".header__nav-sublist")
    };
  
    if (!elements.mobileMenuBtn) return;
  
    // Close mobile menu and reset states
    const closeMobileMenu = () => {
      elements.mobileMenuBtn.classList.remove("active");
      elements.header.classList.remove("mobile-menu-active");
      elements.body.classList.remove("mobile-menu-active");
      elements.nav.classList.remove("nav-active");
      elements.submenus.forEach((submenu) => submenu.classList.remove("active"));
      elements.menuItemIcons.forEach((icon) => icon.classList.remove("active"));
    };
  
    // Add functionality to mob-close
    const mobClose = document.querySelector(".mob-close");
    if (mobClose) {
      mobClose.addEventListener("click", closeMobileMenu);
    }
  
    // Close mobile menu when clicking outside
    elements.body.addEventListener("click", (e) => {
      const isMenuActive = elements.nav.classList.contains("nav-active");
      const isClickInsideNav = elements.nav.contains(e.target);
      const isClickOnMobileMenuBtn = elements.mobileMenuBtn.contains(e.target);
  
      // Close mobile menu if open and click outside nav / btn
      if (isMenuActive && !isClickInsideNav && !isClickOnMobileMenuBtn) {
        closeMobileMenu();
      }
    });
  
    // Toggle mobile menu
    elements.mobileMenuBtn.addEventListener("click", () => {
      const isMenuActive = elements.nav.classList.contains("nav-active");
  
      if (isMenuActive) {
        closeMobileMenu();
      } else {
        elements.mobileMenuBtn.classList.toggle("active");
        elements.body.classList.add("mobile-menu-active");
        elements.nav.classList.add("nav-active");
      }
    });
  
    // Handle menu item icon clicks to toggle submenus
    elements.menuItemIcons.forEach((icon) => {
      icon.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
  
        // Find the nav item (menu item)
        const navItem = icon.closest(".header__nav-item");
        // Only proceed if this nav item has a submenu
        if (
          !navItem ||
          !navItem.classList.contains("header__nav-item--hasMenu")
        )
          return;
  
        // Find the submenu
        const submenu = navItem.querySelector(".header__nav-sublist");
  
        // Remove active from all icons and close all submenus
        elements.menuItemIcons.forEach((otherIcon) => {
          if (otherIcon !== icon) {
            otherIcon.classList.remove("active");
            const otherNavItem = otherIcon.closest(".header__nav-item");   
            if (otherNavItem) {
              const otherSubmenu = otherNavItem.querySelector(".header__nav-sublist");
              if (otherSubmenu) {
                otherSubmenu.classList.remove("active");
                const innerMenus = otherSubmenu.querySelectorAll(".header__nav-sublist");
                innerMenus.forEach((menu) => menu.classList.remove("active"));
              }
            }
          }
        });
  
        // Toggle current submenu
        if (submenu) {
          const wasActive = submenu.classList.contains("active");
          submenu.classList.toggle("active");
          icon.classList.toggle("active");
  
          // If submenu is being closed, also remove active from inner menus
          if (wasActive) {
            const innerMenus = submenu.querySelectorAll(".header__nav-sublist");     
            innerMenus.forEach((menu) =>
              menu.classList.remove("active")
            );
          }
        }
      });
    });


    //toggle search form
    const searchForm = document.querySelector(".header__search-form-wrapper");
    const searchIcon = document.querySelector(".search-icon");
    const closeIcon = document.querySelector(".header__search-form-wrapper .close-icon");
    const searchInput = document.querySelector(".header__search-form-wrapper input[type='search'], .header__search-form-wrapper input[type='text']");

    if (searchForm && searchIcon) {
      searchIcon.addEventListener("click", () => {
        searchForm.classList.toggle("active");
        if (searchForm.classList.contains("active") || searchInput) {
          // Wait for any transition, then focus
          setTimeout(() => searchInput.focus(), 300);
        }
      });

      closeIcon.addEventListener("click", () => {
        searchForm.classList.remove("active");
      });
    } 
  };
  